import { render, staticRenderFns } from "./FormWizardIconTab.vue?vue&type=template&id=36a7eb45&"
import script from "./FormWizardIconTab.vue?vue&type=script&lang=js&"
export * from "./FormWizardIconTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports